import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';
import Websites from '../components/Websites';

class WebsitePage extends Component {
  static propTypes = {
    websites: PropTypes.array.isRequired
  }

  static defaultProps = {
    websites: []
  }

  render() {
    var websites = this.props.websites;
    return (
      <Websites entities={ websites } />
      );
  }
}

WebsitePage = connectToStores(WebsitePage, ['WebsitelandingStore'], (stores, props) => {
  return {
    websites: stores.WebsitelandingStore.get()
  };
});

export default WebsitePage;


// WEBPACK FOOTER //
// ./src/pages/WebsitePage.js